import axios, { AxiosResponse } from "axios";
import { GtfsLineVehicles, TripBusPosition } from '@/lib/gtfsTypes';


async function gtfsGetLineBuses(
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string,
  line: string,
  tripid?: string,
  stopid?: string
): Promise<TripBusPosition[]> {
  let url = `/line-vehicles?reseau=${network}&line=${line}`;
  if (typeof tripid !== 'undefined') {
    url = `${url}&trip=${tripid}`;
  }
  if (typeof stopid !== 'undefined') {
    url = `${url}&stop=${stopid}`;
  }
  if (encodeUriPath) {
    url = encodeURIComponent(url);
  }
  url = `${gtfsUri}${url}`;

  return axios({ method: "get", url }).then(resp => {
    return Object.values(resp.data.Trips);
  });
}

export default function(
  gtfsUri: string,
  encodeUriPath: Boolean,
  network: string,
  line: string,
  tripid?: string,
  stopid?: string,
): Promise<TripBusPosition[]> {

  return gtfsGetLineBuses(gtfsUri, encodeUriPath, network, line, tripid, stopid).then(results => { return results; });

}
